import React from 'react'

export const Alpaka_Zeit = () => {
    return (
        <div className="randBox" id="zeit">
            <h2>Alpaka-Zeit</h2>
            <p>
                Eine Stunde auf der <strong>Alpakawiese</strong>: entspannen, beobachten, fotografieren und einfach genießen –
                ganz nah bei den Tieren. <br />
                Ideal auch für kleinere Kinder – unsere Alpakas sind sehr sanft und besonders im Umgang mit Kindern absolut zuverlässig.
            </p>
            <ul>
            <li><strong>Termine:</strong>
                <ul>
                    <li>Nach Vereinbarung</li>
                </ul>
            </li>
            <li><strong>Preise:</strong>
                <ul>
                    <li>Nach Vereinbarung</li>
                </ul>
            </li>
            </ul>
        </div>
    )

}